const revealTargets = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');

if (revealTargets.length) {
	// 読み込み時点ですでに画面内にある要素は、アニメーションを待たず即表示する
	const isInInitialView = (el) => {
		const rect = el.getBoundingClientRect();
		return rect.top < window.innerHeight && rect.bottom > 0;
	};

	if ('IntersectionObserver' in window) {
		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-inview');
					obs.unobserve(entry.target);
				}
			});
		}, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

		revealTargets.forEach((target) => {
			if (isInInitialView(target)) {
				target.classList.add('is-inview');
			} else {
				observer.observe(target);
			}
		});
	} else {
		revealTargets.forEach((target) => target.classList.add('is-inview'));
	}
}
